import PropTypes from 'prop-types';

// you can see fe-study -> IImEntryProps

export default {
  online: PropTypes.bool,
  newMessageCount: PropTypes.number,
  onClick: PropTypes.func,
};
